import React from 'react';
import { useFormContext } from 'react-hook-form';
import { DiscoveryFilter } from '../../../../../../store/features/discovery';
import { Input } from '../index';

export interface RadioProps {
  data: DiscoveryFilter;
}

export function Radio(props: RadioProps) {
  const {
    data: {
      label,
      count,
      filterValue: { values, type: name },
    },
  } = props;
  const { register } = useFormContext();
  const disabled = count === 0;

  return (
    <Input label={label} count={count} disabled={disabled}>
      <input
        {...register(`${name}.0`)}
        type="radio"
        disabled={disabled}
        value={values[0]}
      />
    </Input>
  );
}
